import React from 'react';
import { inject, observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { isHtml } from '../../utils/util';

const FONT_SIZE = 12;
const IMG_WIDTH = 22;
@inject('rootStore')
@observer
class OneDanmaku extends React.Component {
  @observable transformX = {};
  @action setTransform = () => {
    let text = '12345678';
    try {
      text = decodeURIComponent(this.props.text);
    } catch (e) {}

    let maxWidth = isHtml(text)
      ? document.body.clientWidth + 200
      : document.body.clientWidth +
        this.props.text.length * FONT_SIZE +
        (this.props.image ? IMG_WIDTH : 0);
    this.transformX = {
      transform: `translateX(-${maxWidth}px)`
    };
  };
  //保证用户的文字能在屏幕上停留time的时间
  //因为实际滑动的长度是屏幕宽度+用户的文字的长度
  //所以总的时间应该是time+ 用户的文字需要的时间
  //用户的文字需要的时间= 用户文字长度/当前的速度
  //先不考虑这么复杂了。。。。
  getTotalTime = () => {
    const { /* text, */ time } = this.props;
    //const {clientWidth} = document.body;
    return Math.ceil(time /* + text.length * FONT_SIZE/(clientWidth/time)*/);
  };
  componentDidMount() {
    this.setTransform();
    setTimeout(() => {
      this.props.endCb && this.props.endCb();
    }, this.getTotalTime() + this.props.delay);
  }
  render() {
    //console.log(this.props.top,'top');
    const { text, image } = this.props;
    const { clientWidth } = document.body;

    const totalTime = this.getTotalTime();
    //console.log(totalTime,'totalTime',text.length,'text');
    const style = {
      one: {
        position: 'fixed',
        fontSize: FONT_SIZE,
        color: '#fff',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        left: clientWidth,
        top: this.props.top || 0,
        zIndex: 20,
        transition: `transform ${totalTime}ms linear ${this.props.delay ||
          0}ms`,
        display: 'flex',
        alignItems: 'center'
      },
      img: {
        width: IMG_WIDTH,
        height: IMG_WIDTH,
        borderRadius: 11,
        marginRight: 5
      }
    };

    var decode = '';
    try {
      decode = decodeURIComponent(text);
    } catch (e) {}

    return (
      <div style={Object.assign(style.one, this.transformX)}>
        {image ? <img style={style.img} src={image} alt="" /> : null}
        {isHtml(decode) ? (
          <div dangerouslySetInnerHTML={{ __html: decode }} />
        ) : (
          decode
        )}
      </div>
    );
  }
}

export default OneDanmaku;
